import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { LogLevel, authInterceptor, provideAuth } from 'angular-auth-oidc-client';
import { environment } from '../environments/environment';
import { routes } from './app-routing.module';
import { BrandingInitializerProvider } from './initializers/branding.initializer';
import { clientDetection, encodeBase64 } from './shared/globalFunctions/globalFunctions';
import { OfflineService } from './shared/services/offline.service';
import { RegistryApiService } from './shared/services/registry-api.service';
import { UserContextService } from './shared/services/user-context.service';
import { loaderInterceptor } from './shared/interceptors/loader.interceptor';

export const appConfig: ApplicationConfig = {
    providers: [
        provideHttpClient(withInterceptors([authInterceptor(), loaderInterceptor])),
        provideAuth({
            config: {
                authority: environment.authority,
                authWellknownEndpointUrl: environment.authority + '/.well-known/openid-configuration',
                redirectUrl: environment.redirectUrl,
                postLogoutRedirectUri: environment.redirectUrl,
                clientId: encodeBase64(environment.clientId),
                scope: 'nwn.insight.webapi nwn.insight.identity.webapi offline_access email openid',
                secureRoutes: [environment.API_URL[clientDetection()]],
                responseType: 'code',
                silentRenew: true,
                useRefreshToken: true,
                logLevel: LogLevel.Debug,
                triggerAuthorizationResultEvent: true,
            },
        }),
        RegistryApiService,
        UserContextService,
        OfflineService,
        BrandingInitializerProvider,
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes, withEnabledBlockingInitialNavigation()),
        provideServiceWorker('offline-worker.js', {
            enabled: true, // setting to true so service worker will be enabled for all environments
            registrationStrategy: 'registerWhenStable:30000',
        }),
    ],
};
